module.exports = __webpack_public_path__ + "static/media/kristina-vellucci-cook.9cf32b28.jpeg";